module.exports = __webpack_public_path__ + "static/media/icon-menu.fa8ac0dd.svg";